<template>
  <transition :name="transition" mode="out-in">
    <div
      class="float-container"
      v-show="show || forceShow"
      :style="{ 'flex-direction': direction }"
      :class="{
        'float-container--darker': darker
      }"
    >
      <slot></slot>
    </div>
  </transition>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex';
import { APP_MUTATIONS, APP_GETTERS } from '@/store/modules/app';
export default {
  props: {
    direction: {
      type: String,
      default: 'row'
    },
    transition: {
      type: String,
      default: 'slideup'
    },
    darker: {
      type: Boolean
    },
    show: {
      type: Boolean,
      default: undefined
    }
  },
  data() {
    return {
      forceShow: false
    };
  },
  mounted() {
    this.toggleHeader(true);
    if (this.show === undefined) {
      setTimeout(() => {
        this.forceShow = true;
      }, 500);
    }
  },
  unmounted() {
    this.toggleHeader(false);
  },
  methods: {
    ...mapMutations('app', {
      $setPageSettings: APP_MUTATIONS.SET_PAGE_SETTING
    }),
    toggleHeader(state) {
      this.$setPageSettings({ option: 'show_float_content', value: state });
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@sass/_variables.scss';

.float-container {
  position: fixed;
  bottom: $main-menu-height;
  padding: 20px;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-content: center;
  z-index: 999;
  pointer-events: all;
  background-color: rgba(255, 255, 255, 0.95);

  @media only screen and (min-width: $breakpoint-desktop) {
    left: $side-menu-width !important;
    bottom: 0px;
  }

  div:not(.toolbar) {
    justify-content: center;
    align-content: center;
    display: flex;
  }

  &--darker {
    background: linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0) 0%,
      rgba(0, 0, 0, 1) 40%
    );
  }

  .button,
  a {
    pointer-events: all;
  }
}
</style>

<style lang="scss">
@import '@sass/_variables.scss';
@media only screen and (max-width: $breakpoint-phone) {
  #ButtonCancel {
    flex: 0.5;
    text-align: center;
    justify-content: center;
  }

  .button--primary {
    flex: 2;
    justify-content: center;
  }
}
</style>
